import React, { FC } from 'react';
import { RateCardModel } from '@utmost.co/enterprise-models';
import { DataTableRowActions } from '@utmost.co/utmost-design-system';
import { EditRateCardOption } from './EditRateCardOption';
import { DeleteRateCardOption } from './DeleteRateCardOption';

interface Props {
  onDelete: (uid: string) => void;
  rateCard: RateCardModel;
}

export const RateCardRowActions: FC<React.PropsWithChildren<Props>> = ({ onDelete, rateCard }) => (
  <DataTableRowActions dataTest="rate-card-row-actions">
    <DeleteRateCardOption uid={rateCard.uid} onDelete={onDelete} />
    <EditRateCardOption rateCard={rateCard} />
  </DataTableRowActions>
);
